// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3WbqK","options":"AnswerScale_options__T1Tiq","selected":"AnswerScale_selected__1rfA-"};